module.exports = __webpack_public_path__ + "static/img/WBD.926f376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WBD.svg
// module id = x6mV
// module chunks = 1